import { api } from './ApiService';

export default class UserService {
   
    static async search(data){
        let response =  await api.post(`/user/search`,data)
        return response.data
    }
    
    static async create(data){
        let response = await api.post(`/user/create`,data)
        return response.data
    }
    static async update(data){
        let response = await api.post(`/user/update`,data)
        return response.data
    }

    static async delete(user_id){
        let response = await api.post(`/user/delete`,{user_id:user_id})
        return response.data
    }
}


// WEBPACK FOOTER //
// ./src/service/UserService.js